import React from 'react';
import { Routes, Route } from 'react-router-dom';

import HomePage from './pages/HomePage'
import RecoveryPage from './pages/RecoveryPage';
import ConfirmationPage from './pages/ConfirmationPage';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="reset-password" element={<RecoveryPage />} />
      <Route path="confirmation" element={<ConfirmationPage />} />
    </Routes>
  );
}

export default App;